import { type UserSubOrderV2 } from '@redteclab/api/clients/bully'

import { type OpenableControls } from '../../../generic-hooks'
import { type ContactFormValues } from '../../model/ContactFormValues'
import { directContactFormMakeDefaultValues } from '../../model/directContactFormMakeDefaultValues'

export type DirectContactFormHookFormDialogProduct = {
  name: string
  upid: string
}

export type DirectContactFormHookFormDialogProps = {
  contactFormLaunchOrigin?: string
  disableSubject?: boolean
  formSubject?: string
  isSubjectPharmaRelated?: boolean
  modalControls: OpenableControls
  onClose?: () => void
  onSuccess?: () => void
  onSuccessClose?: () => void
  prefilledSubOrder?: UserSubOrderV2
  product?: DirectContactFormHookFormDialogProduct
}

export type DirectContactFormHookFormDialogValues = ContactFormValues

export const DIRECT_CONTACT_FORM_HOOK_FORM_DIALOG_DEFAULT_VALUES: DirectContactFormHookFormDialogValues =
  {
    ...directContactFormMakeDefaultValues(),
  }
